<template>
    <div class="main-slider">
        <div class="container">
            <div class="main-slider__content">
                <div class="main-slider__content__slider swiper -main-slider">
                    <div class="main-slider__content__slider__wrapper swiper-wrapper">
                        <!-- ITEM -->
                        <div
                            v-for="(slide, idx) in slides"
                            :key="idx"
                            class="main-slider__content__slider__wrapper__item swiper-slide"
                        >
                            <div class="main-slider__content__slider__wrapper__item__bg-image">
                                <picture>
                                    <source v-if="slide.imageMobile" media="(max-width: 768px)" :srcset="slide.imageMobile" />
                                    <source v-if="slide.imageTablet" media="(max-width: 1024px)" :srcset="slide.imageTablet" />

                                    <NuxtImg
                                        v-if="slide.imageDesktop"
                                        loading="lazy"
                                        quality="100"
                                        width="1872"
                                        height="728"
                                        :src="slide.imageDesktop"
                                        :alt="slide.title || title"
                                    />
                                </picture>
                            </div>
                            <div class="main-slider__content__slider__wrapper__item__info">
                                <component
                                    v-if="slide.title"
                                    :is="certainMainHeading(0)"
                                    class="main-slider__content__slider__wrapper__item__info__heading"
                                    >{{ slide.title }}</component
                                >
                                <div
                                    class="main-slider__content__slider__wrapper__item__info__content"
                                    v-if="slide.description"
                                    v-html="slide.description"
                                />
                                <MyActionBtn
                                    class="main-slider__content__slider__wrapper__item__info__btn"
                                    :btnText="slide.btnText"
                                    :theme="'default'"
                                    :size="'default'"
                                    :type="'default'"
                                    :isFreeWidth="true"
                                    :urlPath="slide.url"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="slides?.length > 1" class="main-slider__content__navigation">
                    <MyActionBtn
                        class="main-slider__content__navigation__btn --prev -main-slider-nav-prev"
                        :theme="'transparent'"
                        :size="'default'"
                        :type="'icon'"
                        :icon="'arrowRightIcon'"
                    />
                    <hr />
                    <MyActionBtn
                        class="main-slider__content__navigation__btn --next -main-slider-nav-next"
                        :theme="'transparent'"
                        :size="'default'"
                        :type="'icon'"
                        :icon="'arrowRightIcon'"
                    />
                </div>
                <div v-if="slides?.length > 1" class="main-slider__content__pagination -main-slider-pagination"></div>
            </div>
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import { SliderItem } from './types';
import { Autoplay, Navigation, Pagination, Swiper, Thumbs } from 'swiper';
import MyActionBtn from '@/themes/novaporta/components/ui/MyActionBtn';
export default {
    name: 'MainSlider',
    data() {
        return {
            mainSlider: null
        };
    },
    props: {
        slides: VueTypes.arrayOf(SliderItem).isRequired,
        title: VueTypes.string
    },
    components: {
        MyActionBtn
    },
    watch: {
        slides(newVal, oldVal) {
            this.$nextTick(() => {
                this.initSwiper();
            });
        }
    },
    computed: {
        generateDynamicAutoplay() {
            return this.slides[0]?.autoplay ? this.slides[0]?.autoplay * 1000 : 10000;
        }
    },
    methods: {
        certainMainHeading(index) {
            return index === 0 ? 'h1' : 'h2';
        },

        initSwiper() {
            if (this.mainSlider) {
                this.mainSlider?.destroy(true, true);
            }

            // !!! Use only on client side
            Swiper.use([Navigation, Pagination, Autoplay, Thumbs]);

            this.mainSlider = new Swiper('.-main-slider', {
                slidesPerView: 1,
                spaceBetween: 24,
                allowTouchMove: true,
                grabCursor: true,

                pagination: {
                    el: '.-main-slider-pagination',
                    clickable: true,
                    type: 'bullets',
                    bulletClass: 'main-slider__content__pagination__bullet',
                    bulletActiveClass: 'active'
                },

                // Navigation arrows
                navigation: {
                    nextEl: '.-main-slider-nav-next',
                    prevEl: '.-main-slider-nav-prev'
                },
                autoplay: {
                    delay: this.generateDynamicAutoplay,
                    disableOnInteraction: false
                }
            });
        }
    },
    mounted() {
        this.initSwiper();
    }
};
</script>

<style lang="scss">
@import 'swiper/swiper.scss';
@import './styles.scss';
</style>
